import KycService from "../../services/kyc-service";
import {
	buildKycTileCountsRequestPayload,
	KYC_TILE_COUNT_KEYS,
	unwrapKycTileCountData,
} from "./kycHelpers";

const KYC_TILE_COUNT_REQUESTS = {
	[KYC_TILE_COUNT_KEYS.groupCompany]: (payload) =>
		KycService.getKycGroupCompanyTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.company]: (payload) => KycService.getKycCompanyTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.partnerFunction]: (payload) =>
		KycService.getKycPartnerFunctionTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.contact]: (payload) => KycService.getKycContactTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.material]: (payload) => KycService.getKycMaterialTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.design]: (payload) => KycService.getKycDesignTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.cylinder]: (payload) => KycService.getKycCylinderTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.quotation]: (payload) => KycService.getKycQuotationTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.quality]: (payload) => KycService.getKycQualityTileCountsAPI(payload),
	[KYC_TILE_COUNT_KEYS.businessOverview]: (payload) =>
		KycService.getKycBusinessOverviewTileCountsAPI(payload),
};

export const createKycTileLoadingMap = (tileKeys = [], isLoading = false) =>
	tileKeys.reduce((loadingMap, tileKey) => {
		loadingMap[tileKey] = Boolean(isLoading);
		return loadingMap;
	}, {});

export const fetchKycSeparateTileCounts = (
	payload,
	tileKeys = [],
	scope = {},
	onTileLoaded
) => {
	const requestPayload = buildKycTileCountsRequestPayload(payload, scope);

	return Promise.all(
		tileKeys.map((tileKey) => {
			const request = KYC_TILE_COUNT_REQUESTS[tileKey];
			const finish = (data) => {
				const tileData = data || {};
				if (typeof onTileLoaded === "function") {
					onTileLoaded(tileKey, tileData);
				}
				return { tileKey, data: tileData };
			};

			if (!request) {
				return Promise.resolve(finish({}));
			}

			return request(requestPayload)
				.then((response) =>
					finish(
						response?.data?.statusCode === 200
							? unwrapKycTileCountData(response.data.responseData || {}, tileKey)
							: {}
					)
				)
				.catch((error) => {
					console.log(error, "Error");
					return finish({});
				});
		})
	).then((results) =>
		results.reduce((counts, item) => {
			counts[item.tileKey] = item.data || {};
			return counts;
		}, {})
	);
};
